import i18n from 'i18next'
// Add again in future
//import LanguageDetector from 'i18next-browser-languagedetector'

i18n
  // .use(LanguageDetector)
  .init({
    // we init with resources
    resources: {
      de: {
        translations: {
          "API-Portal": "API-Portal",
          "Aktuelles": "Aktuelles",
          "Überblick": "Überblick",
          "Profile": "Profile",
          "APIs": "APIs",
          "Apps &amp; Tools": "Apps &amp; Tools",
          "Dokumentation": "Dokumentation",
          "Kontakt": "Kontakt",
          "Anmelden": "Anmelden",
          "Abmelden": "Abmelden",
          "Aktuell stehen keine Aufschaltungen zur Verfügung. Bitte kontaktieren Sie uns.": "Aktuell stehen keine Aufschaltungen zur Verfügung. Bitte kontaktieren Sie uns.",
          "Mitteilungen": "Mitteilungen",
          "Artikel": "Artikel",
          "Stand": "Stand",
          "Abbrechen": "Abbrechen",
          "Zurück": "Zurück",
          "Weiter": "Weiter",
          "Fertig": "Fertig",
          "s3push API Einrichten": "s3push-API Einrichten",
          "Hilfe": "Hilfe",
          "Mehr": "Mehr",
          "Aktiv": "Aktiv",
          "Inaktiv": "Inaktiv",
          "Deaktiviert": "Deaktiviert",
          "Deaktivieren": "Deaktivieren",
          "S3-URL-Präfix": "S3-URL-Präfix",
          "URL-Präfix": "URL-Präfix",
          "Access Key ID": "Access Key ID",
          "Secret Access Key": "Secret Access Key",
          "Aktivieren": "Aktivieren",
          "Letzte Belieferung": "Letzte Belieferung",
          "Aktualisieren": "Aktualisieren",
          "Log": "Log",
          "Erreichbarkeit": "Erreichbarkeit",
          "Editieren": "Editieren",
          "Lokale Installation": "Lokale Installation",
          "Einrichten": "Einrichten",
          "Erreichbarkeit Testen": "Erreichbarkeit Testen",
          "Belieferung": "Belieferung",
          "jsonfeed-unverified": "Ihr Feed der jsonfeed-API «<1>{{nickname}}</1>» kann erst aktiviert werden, wenn Sie Ihre E-Mail-Adresse (siehe Registrierungs-Mail) bestätigt haben.",
          "jsonfeed-auto-expire": `Ihr Feed der jsonfeed-API «<1>{{nickname}}</1>» wurde automatisch deaktiviert. Klicken Sie auf "Aktivieren", um den Feed zu aktivieren.`,
          "jsonfeed-expired": `Ihr Feed der jsonfeed-API «<1>{{nickname}}</1>» ist leider abgelaufen.<3 />Kontaktieren Sie bitte unseren <5>Kundenservice</5>, wenn Sie an einer weiteren Belieferung interessiert sind.`,
          "json-feed-inactive": `Der jsonfeed für «<1>{{nickname}}</1>» ist noch nicht eingerichtet. Klicken Sie auf "Aktivieren", um den Feed zu aktivieren.`,
          "wireq-unverified": "Ihr Feed der wireq-API «<1>{{nickname}}</1>» kann erst aktiviert werden, wenn Sie Ihre E-Mail-Adresse (siehe Registrierungs-Mail) bestätigt haben.",
          "wireq-auto-expire": `Ihr Feed der wireq-API «<1>{{nickname}}</1>» wurde automatisch deaktiviert. Klicken Sie auf "Aktivieren", um den Feed zu aktivieren.`,
          "wireq-expired": `Ihr Feed der wireq-API «<1>{{nickname}}</1>» ist leider abgelaufen.<3 />Kontaktieren Sie bitte unseren <5>Kundenservice</5>, wenn Sie an einer weiteren Belieferung interessiert sind.`,
          "wireq-feed-inactive": `Der wireQ-Feed für «<1>{{nickname}}</1>» ist noch nicht eingerichtet. Klicken Sie auf "Aktivieren", um den Feed zu aktivieren.`,
          "s3push-unverified": "Ihr Feed der s3push-API «<1>{{nickname}}</1>» kann erst aktiviert werden, wenn Sie Ihre E-Mail-Adresse (siehe Registrierungs-Mail) bestätigt haben.",
          "s3push-auto-expire": `Ihr Feed der s3push-API «<1>{{nickname}}</1>» wurde automatisch deaktiviert. Klicken Sie auf "s3push-API Einrichten", um den Feed zu aktivieren.`,
          "s3push-expired": `Ihr Feed der s3push-API «<1>{{nickname}}</1>» ist leider abgelaufen.<3 />Kontaktieren Sie bitte unseren <5>Kundenservice</5>, wenn Sie an einer weiteren Belieferung interessiert sind.`,
          "s3push-not-yet-installed-api-1": `
            s3push für «<1>{{nickname}}</1>» ist noch nicht eingerichtet. Klicken Sie auf "s3push-API Einrichten", um den Feed zu aktivieren.`,
          "s3push-initial-2": `
            Was ist die s3push-API? Informieren Sie sich im <1>Bereich der Dokumentation</1>.`,
          "s3push-help-1": `
            Hier finden Sie eine Beschreibung, wie Sie mittels serverless<1 />
            einen S3 Bucket anlegen und die benötigten Daten auslesen.`,
          "s3push-intro-1": `
            Um Meldungen per s3push-API zu empfangen, müssen Sie ein S3 Bucket mit
            geeigneten Zugriffsrechten in ihrem AWS-Account erzeugen.`,
          "s3push-intro-2": `
            In unserem <1>Github-Repository</1>
            finden Sie diverse Best Practices (<3>eine Basis Implementierung</3>,
            <5>eine erweiterte Implementierung mit Konvertierungsfunktion</5> und
            <7>eine erweiterte Implementierung mit Webhook-Aufruf</7>).
            Die Installationsanleitung entnehmen Sie bitte der jeweiligen README-Datei des
            <1>Github-Projekts</1>, für das Sie sich entschieden haben.`,
          "s3push-intro-3": `
            Ändern sie den gewünschten Bucket-Namen (das Bucket darf noch nicht existieren) und den Pfad-Präfix in serverless.yml.`,
          "s3push-intro-4": `
            Bitte konfigurieren sie AWS-Credentials eines Admin-Users für den gewünschten
            AWS-Account. (<1>Hinweise</1>)`,
          "s3push-intro-5": `
            Erstellen Sie jetzt das Bucket und weitere benötigte Ressourcen:`,
          "s3push-intro-6": `
            Bitte tragen Sie die Ausgaben für S3-URL-Präfix, Access Key ID und Secret Access Key im nächsten Schritt in das Formular ein.`,
          "s3push-intro-7": `
            Es gibt <1>alternative Installationsmethoden</1>.`,
          "s3push-delivery-1": `
            Die s3push-API konnte erfolgreich eingerichtet werden.
            Ein initialer Artikelbestand wird in Kürze übertragen.`,
          "s3push-delivery-2": `
            Klicken Sie auf <1>"Fertig"</1> stellen, um den Assistenten zu
            verlassen und die Installation abzuschließen.`,
          "s3push-delivery-3": `
            Die s3push-API konnte <1>nicht</1> eingerichtet werden.
            Bitte prüfen Sie die Einstellungen und testen die Erreichbarkeit erneut.`,
          "s3push-delivery-4": `
            Klicken Sie auf <1>"Fertig"</1> stellen, um den Assistenten zu verlassen.`,
          "Bitte bestätigen Sie Ihre E-Mail-Adresse (Siehe Registrierungs-Mail)!": `
            Bitte bestätigen Sie Ihre E-Mail-Adresse (Siehe Registrierungs-Mail)!`,
          "sftppush-help-1": `
            Hier finden Sie eine Beschreibung, wie Sie mittels serverless<1 />
            einen S3 Bucket anlegen und die benötigten Daten auslesen.`,
          "sftppush-not-yet-installed-api-1": `
            sftppush für «<1>{{nickname}}</1>» ist noch nicht eingerichtet. Klicken Sie auf "sftppush-API Einrichten", um den Feed zu aktivieren.`,
          "sftppush-initial-2": `
            Was ist die sftppush-API? Informieren Sie sich im <1>Bereich der Dokumentation</1>.`,
          "sftppush-intro-1": `
            Um Meldungen per sftppush-API zu empfangen, müssen Sie einen SFTP-Server mit geeigneten Zugriffsrechten zur Verfügung stellen.`,
          "sftppush-intro-2": `Bitte richten Sie auf dem SFTP-Server einen dedizierten User ein für folgenden Public Key:`,
          "sftppush-intro-3": `Folgende statische Quell-IP-Adressen stehen zur Verfügung. Bitte verwenden Sie diese für Ihre Firewall-Konfiguration:`,
            "sftppush-delivery-1": `
            Die sftppush-API konnte erfolgreich eingerichtet werden.
            Ein initialer Artikelbestand wird in Kürze übertragen.`,
          "sftppush-delivery-2": `
            Klicken Sie auf <1>"Fertig"</1> stellen, um den Assistenten zu
            verlassen und die Installation abzuschließen.`,
          "sftppush-unverified": "Ihr Feed der sftppush-API «<1>{{nickname}}</1>» kann erst aktiviert werden, wenn Sie Ihre E-Mail-Adresse (siehe Registrierungs-Mail) bestätigt haben.",
          "sftppush-auto-expire": `Ihr Feed der sftppush-API «<1>{{nickname}}</1>» wurde automatisch deaktiviert. Klicken Sie auf "sftppush-API Einrichten", um den Feed zu aktivieren.`,
          "sftppush-expired": `Ihr Feed der sftppush-API «<1>{{nickname}}</1>» ist leider abgelaufen.<3 />Kontaktieren Sie bitte unseren <5>Kundenservice</5>, wenn Sie an einer weiteren Belieferung interessiert sind.`,
          "sftppush-staticips-1": "Statische Quell-IP-Adressen"
        }
      },
      en: {
        translations: {
          "API-Portal": "API customer portal",
          "Aktuelles": "News",
          "Überblick": "Overview",
          "Profile": "Profiles",
          "APIs": "APIs",
          "Apps &amp; Tools": "Apps &amp; Tools",
          "Dokumentation": "Documentation",
          "Kontakt": "Contact",
          "Anmelden": "Login",
          "Abmelden": "Logout",
          "Aktuell stehen keine Aufschaltungen zur Verfügung.": "There are no 'Aufschaltungen' currently available. Please contact us.",
          "Mitteilungen": "Notifications",
          "Artikel": "Article",
          "Stand": "Status",
          "Abbrechen": "Cancel",
          "Zurück": "Back",
          "Weiter": "Next",
          "Fertig": "Finish",
          "s3push-API Einrichten": "Setup s3push-API",
          "Hilfe": "Help",
          "Mehr": "More",
          "Aktiv": "Active",
          "Inaktiv": "Inactive",
          "Deaktiviert": "Deactivated",
          "Deaktivieren": "Deactivate",
          "S3-URL-Präfix": "S3-URL-Prefix",
          "URL-Präfix": "URL-Prefix",
          "Access Key ID": "Access Key ID",
          "Secret Access Key": "Secret Access Key",
          "Aktivieren": "Activate",
          "Letzte Belieferung": "Last delivery",
          "Aktualisieren": "Refresh",
          "Log": "Log",
          "Erreichbarkeit": "Reachability",
          "Editieren": "Edit",
          "Lokale Installation": "Locale Installation",
          "Einrichten": "Setup",
          "Erreichbarkeit Testen": "Reachability Test",
          "Belieferung": "Delivery",
          "jsonfeed-unverified": "Your feed of the jsonfeed-API «<1>{{nickname}}</1>» can be activated only after you have confirmed your email address (see registration email).",
          "jsonfeed-auto-expire": `Your feed of the jsonfeed-API «<1>{{nickname}}</1>» was automatically deactivated. Click on "Activate" to activate the feed.`,
          "jsonfeed-expired": `Your feed of the jsonfeed-API «<1>{{nickname}}</1>» has expired.<3 />Please contact our <5>Customer Service</5> if you are interested in a further delivery.`,
          "json-feed-inactive": `The jsonfeed for «<1>{{nickname}}</1>» is not yet set up. Click on "Activate" to activate the feed.`,
          "wireq-unverified": "Your feed of the wireq-API «<1>{{nickname}}</1>» can be activated only after you have confirmed your email address (see registration email).",
          "wireq-auto-expire": `Your feed of the wireq-API «<1>{{nickname}}</1>» was automatically deactivated. Click on "Activate" to activate the feed.`,
          "wireq-expired": `Your feed of the wireq-API «<1>{{nickname}}</1>» has expired.<3 />Please contact our <5>Customer Service</5> if you are interested in a further delivery.`,
          "wireq-feed-inactive": `The wireQ-Feed for «<1>{{nickname}}</1>» is not yet set up. Click on "Activate" to activate the feed.`,
          "s3push-unverified": "Your feed of the s3push-API «<1>{{nickname}}</1>» can be activated only after you have confirmed your email address (see registration email).",
          "s3push-auto-expire": `Your feed of the s3push-API «<1>{{nickname}}</1>» was automatically deactivated. Click on "Activate" to activate the feed.`,
          "s3push-expired": `Your feed of the s3push-API «<1>{{nickname}}</1>» has expired.<3 />Please contact our <5>Customer Service</5> if you are interested in a further delivery.`,
          "s3push-not-yet-installed-api-1": `The s3push for «<1>{{nickname}}</1>» is not yet set up. Click on "Setup s3push-API" to activate the feed.`,
          "s3push-initial-2": `
            What is the s3push-API? Inform yourself in the <1>documentation area</1>.`,
          "s3push-help-1": `
            Here you will find a description of how to create a S3 bucket<1 />
            using serverless and how to read the required data.`,
          "s3push-intro-1": `
            To receive articles via s3push, you must create a S3 bucket with appropriate access rights in your AWS account.`,
          "s3push-intro-2": `
            In our <1>Github repository</1> you will find various best practices
            (<3>a basic implementation</3>, <5>an advanced implementation with a conversion</5> and
            <7>an advanced implementation using a webhook request</7>).
            You can find the installation instructions in the README file of the 
            <1>Github repository</1>, you have chosen.`,
          "s3push-intro-3": `
            Change the bucket name (the bucket must not yet exist) and the path prefix in serverless.yml.`,
          "s3push-intro-4": `
            Please configure AWS credentials of an admin user for the desired AWS account. (<1>references</1>)`,
          "s3push-intro-5": `
            Now create the bucket and other required resources:`,
          "s3push-intro-6": `
            Please enter the output for S3 URL prefix, Access Key ID und Secret Access Key in the next step in the form.`,
          "s3push-intro-7": `
            There are <1>alternative installation methods</1>.`,
          "s3push-delivery-1": `
            The s3push-API could be set up successfully.
            An initial article stock will be transferred shortly.`,
          "s3push-delivery-2": `
            Click <1>"Finish"</1> to exit the wizard and to complete the installation.`,
          "s3push-delivery-3": `
            The s3push-API could <1>not</1> be set up.
            Please check the settings and test the availability again.`,
          "s3push-delivery-4": `
            Click on <1>"Finish"</1> to leave the assistant.`,
          "Bitte bestätigen Sie Ihre E-Mail-Adresse (Siehe Registrierungs-Mail)!": `
            Please confirm your email address (See registration email)!`,
          "sftppush-help-1": `
            Hier finden Sie eine Beschreibung, wie Sie mittels serverless<1 />
            einen S3 Bucket anlegen und die benötigten Daten auslesen.`,
          "sftppush-not-yet-installed-api-1": `The sftppush for «<1>{{nickname}}</1>» is not yet set up. Click on "Setup sftppush-API" to activate the feed.`,
          "sftppush-initial-2": `
            What is the sftppush-API? Inform yourself in the <1>documentation area</1>.`,
          "sftppush-intro-1": `
            To receive articles via sftppush, you must provide an SFTP server with suitable access rights.`,
          "sftppush-intro-2": `Please set up a dedicated user on the SFTP server for the following public key:`,
          "sftppush-intro-3": `The following static source IP addresses are available. Please use these for your firewall configuration:`,
            "sftppush-delivery-1": `
            The sftppush-API could be set up successfully.
            An initial article stock will be transferred shortly.`,
          "sftppush-delivery-2": `
            Click <1>"Finish"</1> to exit the wizard and to complete the installation.`,
          "sftppush-unverified": "Your feed of the sftppush-API «<1>{{nickname}}</1>» can be activated only after you have confirmed your email address (see registration email).",
          "sftppush-auto-expire": `Your feed of the sftppush-API «<1>{{nickname}}</1>» was automatically deactivated. Click on "Activate" to activate the feed.`,
          "sftppush-expired": `Your feed of the sftppush-API «<1>{{nickname}}</1>» has expired.<3 />Please contact our <5>Customer Service</5> if you are interested in a further delivery.`,
          "sftppush-staticips-1": "Static source IP adresses"
        }
      }
    },
    fallbackLng: 'de',
    debug: false,

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false, // not needed for react!!
      formatSeparator: ','
    },

    react: {
      wait: true
    }
  })

export default i18n



// WEBPACK FOOTER //
// ./src/i18n.js